export default{
  label:'font-weight',
  valueScope:[
    'font-weight-bold',
    'font-weight-bolder',
    'font-weight-normal',
    'font-weight-light',
    'font-weight-lighter',
  ],
}



// WEBPACK FOOTER //
// ./src/shell/schemas/general/text/weight.js